angular.module('app.dashboard', [
  'ui.router',
  'toastr',
  'app.dashboardService',
  'zingchart-angularjs'
])

.config(
  [          '$stateProvider', '$urlRouterProvider',
    function ($stateProvider,   $urlRouterProvider) {
      $stateProvider
        .state('index.dashboard', {
          abstract: true,
          url: 'mediacion',
          params: {
          },
          views: {
            '': {
              templateUrl: 'app/dashboard/dashboard.tpl.html',
              resolve: {

              },
              controller: ['$scope', '$state', 'toastr',
                function (  $scope,   $state,   toastr) {



                }]
            }
          }

        })
        .state( 'index.dashboard.list', {
          url: '',
          views: {
            '': {
              templateUrl: 'app/dashboard/dashboard.list.tpl.html',
              /*resolve: 
                {
                  dataBaseColor: ['dashboardService',function( dashboardService){return dashboardService.getBaseColor()}]
                },*/
                controller: ['$scope', '$state', 'toastr','dashboardService', '$document', 'parametrizacionService',
                  function (  $scope,   $state,   toastr , dashboardService, $document, parametrizacionService) 
                {

                //cambio de pestaña activa
                $scope.enfoqueServicios(2);

                //descripción de meses y días
                meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
                dias = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

                //se obtienen los centros de mediacion
                $scope.centros = [];
                $scope.control_centros = 2;
                $scope.control_regiones = 2;

                $scope.cargarCentros = function(departamento)
                {
                  dashboardService.getDespachos(departamento, -1, -1).then( 
                    function ( response ) 
                    {                   
                      //$scope.centros = [];
                      //$scope.centros = response.data;
                      $scope.rangoEstadisticas.ID_DESPACHO = "0";
                      $scope.mostrar_centros = true;
                      $scope.control_centros = 1;
                      //realizar la verificación de centros
                      //con $scope.control_centros
                      /*if ($scope.centros.length == 2)
                      {
                        $scope.mostrar_centros = false;
                        if (($scope.rangoEstadisticas.ID_DEPARTAMENTO > 0) && ($scope.menucentros))
                        {
                          $scope.enfocarPestana(1);
                        }
                      }*/
                    }, 
                    function ( error ) 
                    {
                      toastr.error( error );
                    });
                }
                //$scope.cargarCentros("0");

                $scope.dataDepartamentos = [];
                //$scope.dataDepartamentos = dataDepartamento.data;

                $scope.selectedRegionExterno = function()
                {
                  //$scope.labelsChartDepartamento=[""];
                  //$scope.dataChartDepartamento=["0"];
                  $scope.selectedRegion($scope.dataRegiones[0],false);
                }

                $scope.selectedDepartamentoExterno = function()
                {
                  //$scope.labelsChartDepartamento=[""];
                  //$scope.dataChartDepartamento=["0"];
                  cargaDepartamentos($scope.rangoEstadisticas.ID_REGION,false);
                }
                
                reinicioDataLabelChart = function()
                {
                  if ($scope.dataChartRegion != undefined)
                  {
                    if ($scope.menuregiones)
                    {
                      ciclo = $scope.dataChartRegion.length;
                      for (c=0; c<ciclo; c++)
                      {
                        $scope.dataChartRegion[c] = "";
                      }
                    }
                    else
                    {
                      $scope.dataChartRegion = [""];
                      $scope.labelsChartRegion = [""]
                    }
                  }

                  if ($scope.dataChartDepartamento != undefined)
                  {
                    if ($scope.menudepartamentos)
                    {
                      ciclo = $scope.dataChartDepartamento.length;
                      for (c=0; c<ciclo; c++)
                      {
                        $scope.dataChartDepartamento[c] = "";
                      }
                    }
                    else
                    {
                      $scope.dataChartDepartamento = [""];
                      $scope.labelsChartDepartamento = [""];
                    }
                  }
                  
                  if ($scope.dataChartMapa1 != undefined)
                  {
                    if ($scope.menucentros)
                    {
                      ciclo = $scope.dataChartMapa1.length;
                      for (c=0; c<ciclo; c++)
                      {
                        $scope.dataChartMapa1[c] = "";
                      }
                    }
                    else
                    {
                      $scope.dataChartMapa1 = [""];
                      $scope.labelsChartMapa1 = [""];
                      $scope.topChartMapa1 = [];
                      $scope.topInicialChartMapa1 = [];
                      $scope.topFinalChartMapa1 = [];
                    }
                  }

                  if ($scope.dataChartMateria != undefined)
                  {
                    if ($scope.menumaterias)
                    {
                      ciclo = $scope.dataChartMateria.length;
                      for (c=0; c<ciclo; c++)
                      {
                        $scope.dataChartMateria[c] = "";
                      }
                    }
                    else
                    {
                      $scope.dataChartMateria = [""];
                      $scope.labelsChartMateria = [""];
                    }
                  }

                  if ($scope.dataChartIdioma != undefined)
                    {
                      if ($scope.menuidiomas)
                      {
                        ciclo = $scope.dataChartIdioma.length;
                        for (c=0; c<ciclo; c++)
                        {
                          $scope.dataChartIdioma[c] = "";
                        }
                      }
                      else
                      {
                        $scope.dataChartIdioma = [""];
                        $scope.labelsChartIdioma = [""];
                      }
                    }

                  if ($scope.dataChartSexo != undefined)
                  {
                    if ($scope.menusexos)
                    {
                      ciclo = $scope.dataChartSexo.length;
                      for (c=0; c<ciclo; c++)
                      {
                        $scope.dataChartSexo[c] = "";
                      }
                    }
                    else
                    {
                      $scope.dataChartSexo = [""];
                      $scope.labelsChartSexo = [""];
                    }
                  }
                }

                $scope.selectedDepartamento = function (item,externo,comboexterno)
                {
                  if (comboexterno)
                  {
                    $scope.grafica_departamentos_activa = false;
                  }

                  reinicioDataLabelChart();

                  $scope.rangoEstadisticas.ID_DEPARTAMENTO = item.ID_DEPARTAMENTO;
                  $scope.rangoEstadisticas.DEPARTAMENTO = item.DEPARTAMENTO;
                  $scope.rangoEstadisticas.ID_DESPACHO = "0";
                  $scope.currentItem = undefined;

                  if (externo && $scope.grafica_departamentos_activa)
                  {
                    $scope.enfocarPestana(2,false);
                  }
                  else if ($scope.grafica_departamentos_activa)
                  {
                    $scope.enfocarPestana(7,false);
                  }
                  else if ((item.ID_DEPARTAMENTO > 0) && (($scope.menuregiones) || ($scope.menudepartamentos)))
                  {
                    $scope.enfocarPestana(1,true);
                  }

                  if (($scope.rangoEstadisticas.ID_REGION > 0) && (item.ID_DEPARTAMENTO == 0))
                  {
                    $scope.tooltip_mapa="Para filtrar un departamento de la región, haga clic en su ubicación"; 
                    $scope.tooltip_mapaB = "Para volver a todas las regiones, haga clic en un departamento no filtrado";
                  }
                  else if (($scope.rangoEstadisticas.ID_REGION > 0) && (item.ID_DEPARTAMENTO > 0))
                  {
                    $scope.tooltip_mapa = "Para volver a todos los departamentos de la región, haga clic en un departamento no filtrado";
                    $scope.tooltip_mapaB="";
                  }
                  else if (item.ID_DEPARTAMENTO > 0 )
                  {
                    $scope.tooltip_mapa="";
                    $scope.tooltip_mapaB = "";
                  }
                  $scope.cargaEstadisticas(true);
                }

                //se cargan los departamentos
                cargaDepartamentos = function(region)
                {
                  $scope.dataDepartamentos = [];
                  parametrizacionService.getDeptoMunicipioCentros(region,1,7).then( function ( response ) {
                    $scope.dataDepartamentos=response.data;
                    $scope.selectedDepartamento($scope.dataDepartamentos[0],false);
                  }, function ( error ) {
                    toastr.error( error );
                  });
                }

                $scope.selectedRegion = function (item,externo,comboexterno)
                {
                  if (comboexterno)
                  {
                    $scope.grafica_regiones_activa = false;
                  }

                  $scope.rangoEstadisticas.ID_REGION = item.ID_REGION;
                  $scope.rangoEstadisticas.REGION = item.REGION;
                  $scope.rangoEstadisticas.COLOR = item.COLOR;
                  $scope.currentItem = undefined;

                  if (externo && $scope.grafica_regiones_activa && !$scope.grafica_departamentos_activa)
                  {
                    $scope.enfocarPestana(7,false);
                  }
                  else if (!externo && $scope.grafica_regiones_activa && $scope.grafica_departamentos_activa)
                  {
                    $scope.grafica_departamentos_activa = false;
                    $scope.enfocarPestana(6,false);
                  }
                  else if ($scope.grafica_regiones_activa && !$scope.grafica_departamentos_activa)
                  {
                    $scope.enfocarPestana(6,false);
                  }
                  else if ((item.ID_REGION > 0) && ($scope.menuregiones))
                  {
                    $scope.enfocarPestana(1,true);
                  }

                  if (item.ID_REGION == 0)
                  {
                    $scope.tooltip_mapa = "Para filtrar una región, haga clic en un departamento";
                    $scope.tooltip_mapaB = "";
                  }
                  else if (item.ID_REGION > 0)
                  {
                    $scope.tooltip_mapa="Para filtrar un departamento de la región, haga clic en su ubicación";
                    $scope.tooltip_mapaB = "Para volver a todas las regiones, haga clic en un departamento no filtrado";
                  }
                  cargaDepartamentos(item.ID_REGION);
                }

                cargaRegiones = function()
                {
                  $scope.dataRegiones = [];
                  parametrizacionService.getDeptoMunicipioCentros(0,0,6).then( function ( response ) {
                    $scope.dataRegiones=response.data;
                    $scope.selectedRegion($scope.dataRegiones[0],false);
                  }, function ( error ) {
                    toastr.error( error );
                  });
                }

                cargaRegiones();

                //se selecciona el centro de mediacion y se obtienen sus mediadores
                $scope.mostrar_mapa = true;
                $scope.mostrar_centros = true;
                $scope.selectedCentro = function (item)
                {
                  $scope.rangoEstadisticas.ID_DESPACHO = item.ID_DESPACHO;
                  $scope.rangoEstadisticas.DESPACHO = item.DESPACHO;

                  $scope.mostrar_mapa = true;
                  $scope.mostrar_centros = true;
                  if (item.ID_DESPACHO > 0)
                  {
                    $scope.mostrar_mapa = false;
                    $scope.mostrar_centros = false;
                    if ($scope.menumapa || $scope.menucentros)
                    {
                      $scope.enfocarPestana(3,true);
                    } 
                  }
                  if ($scope.centros.length == 2)
                  {
                    $scope.mostrar_centros = false;
                  }

                  $scope.cargaEstadisticas(true);
                }

                $scope.selectedRango = function (item)
                {
                  $scope.rangoEstadisticas.ID_RANGO = item.ID_RANGO;
                  $scope.cargaEstadisticas(true);
                }

                fechaTituloDia = function(date)
                {
                  d = new Date(date);
                  day = d.getDate();
                  dia = dias[d.getDay()];
                  mes = meses[d.getMonth()];
                  anio= d.getFullYear();
                  tituloCalendario = ' el '+dia+' '+day +' de '+ mes +' de '+  anio;
                  return tituloCalendario;
                }

                fechaTituloRangoDiasSemana = function(numerodiainicio,diainicio, mesinicio, anioinicio, numerodiafin, diafin, mesfin, aniofin)
                {
                  //d = new Date(date);
                  //day = d.getDay();
                  //diff = d.getDate() - day + (day == 0 ? -6 : 1);
                  //inicio = new Date(d.setDate(diff));            
                  //d = new Date(date);
                  //day = d.getDay();
                  //diff = d.getDate() - day + (day == 0 ? -6 : 5);
                  //viernes = new Date(d.setDate(diff));
                  diaInicial = diainicio; //inicio.getDate();
                  diaInicialNombre = dias[numerodiainicio];
                  mesInicial = meses[mesinicio-1];//meses[inicio.getMonth()];
                  anioInicial= anioinicio;//inicio.getFullYear();
                  diaFinal = diafin;//viernes.getDate();
                  diaFinalNombre = dias[numerodiafin];
                  mesFinal = meses[mesfin-1];//meses[viernes.getMonth()];
                  anioFinal= aniofin;//viernes.getFullYear();
                  tituloCalendario = ' del '+diaInicialNombre+' '+diaInicial;
                  
                  if (mesInicial != mesFinal)
                  {
                    tituloCalendario = tituloCalendario +' de '+ mesInicial;
                  }
                  else if ((mesInicial == mesFinal) && (anioInicial != anioFinal))
                  {
                    tituloCalendario = tituloCalendario +' de '+ mesInicial;
                  }

                  if (anioInicial != anioFinal)
                  {
                    tituloCalendario = tituloCalendario +' de '+ anioInicial;
                  }
                  
                  tituloCalendario = tituloCalendario +' al '+diaFinalNombre+' '+diaFinal+' de '+mesFinal+' de '+anioFinal;
                  return tituloCalendario;
                }

                fechaTituloRangoDiasMes = function(date)
                {
                  d = new Date(date);
                  mes = meses[d.getMonth()];
                  anio= d.getFullYear();
                  tituloCalendario = ' en '+mes +' de '+  anio;
                  return tituloCalendario;
                }

                fechaTituloRangoDiasAnio = function(date)
                {
                  d = new Date(date);
                  anio= d.getFullYear();
                  tituloCalendario = anio;
                  return ' en '+tituloCalendario;
                }

                //titulo rango de fechas
                fechaTituloFechas = function(fechainicio, fechafin)
                {
                  
                  fechainicial = new Date(fechainicio)
                  diainicio = fechainicial.getDate();
                  mesinicio = fechainicial.getMonth()+1;
                  anioinicio = fechainicial.getFullYear();

                  fechafinal = new Date(fechafin)
                  diafin = fechafinal.getDate();
                  mesfin = fechafinal.getMonth()+1;
                  aniofin = fechafinal.getFullYear();
                  
                  ultimodiamesfechafin = new Date(fechafinal.getFullYear(), fechafinal.getMonth()+1, 0);
                  ultimodiamesfin = ultimodiamesfechafin.getDate();                  

                  if ((anioinicio == aniofin) && (mesinicio == mesfin) && (diainicio == diafin))
                  {
                    $scope.fecha_tipo_casos_texto = fechaTituloDia(fechainicio);
                  }
                  else if((anioinicio == aniofin) && (mesinicio == mesfin) && (diainicio == 1) && (diafin == ultimodiamesfin))
                  {
                    $scope.fecha_tipo_casos_texto = fechaTituloRangoDiasMes(fechainicio);
                  }
                  else if((anioinicio == aniofin) && (mesinicio == 1) && (mesfin == 12) && (diainicio == 1) && (diafin == ultimodiamesfin))
                  {
                    $scope.fecha_tipo_casos_texto = fechaTituloRangoDiasAnio(fechainicio);
                  }
                  else
                  {
                    $scope.fecha_tipo_casos_texto = fechaTituloRangoDiasSemana(fechainicial.getDay(),diainicio,mesinicio,anioinicio,fechafinal.getDay(),diafin,mesfin,aniofin);
                  }
                }

                $scope.registrosChartDepartamentosCentros = "";
                $scope.paginacionGraficaCasosCentrosDepartamento = function(item)
                {
                  $scope.currentItem = $scope.topChartMapa1[item-1];
                  $scope.registrosChartDepartamentosCentros = $scope.topInicialChartMapa1[item-1]
                  +"-"+$scope.topFinalChartMapa1[item-1]+" de "
                  +$scope.topFinalChartMapa1[($scope.topFinalChartMapa1.length)-1]
                  +" registros";
                  
                  $scope.labelsChartMapa1 = [];
                  $scope.dataChartMapa1 = [];
                  $scope.backgroundColorChartMapa1 = [];

                  for (i=($scope.topInicialChartMapa1[item-1])-1;i < $scope.topFinalChartMapa1[item-1];i++)
                  {
                    $scope.labelsChartMapa1.push($scope.labelsChartMapa1Temp[i]);
                    $scope.dataChartMapa1.push($scope.dataChartMapa1Temp[i]);
                    $scope.backgroundColorChartMapa1.push($scope.backgroundColorChartMapa1Temp[i]);
                  }
                }

                //mapa
                mapa = function(fecha,fechaFin,tipodatos)
                {
                  dashboardService.getDatosTablero($scope.rangoEstadisticas.ID_REGION,$scope.rangoEstadisticas.ID_DEPARTAMENTO,$scope.rangoEstadisticas.ID_DESPACHO,fecha,fechaFin,tipodatos,$scope.rangoEstadisticas.ID_BASE_COLOR).then( function ( response ) {
                    $scope.dataMetricaRegistradosMapa=response.data;
                    $scope.zingMap1.shapes[0].options.style.items=response.data.mapa;
                    $scope.labelsChartDepartamento=response.data.labels;
                    $scope.dataChartDepartamento=response.data.data;
                    $scope.backgroundColorChartDepartamento=response.data.colors;
                    if ($scope.rangoEstadisticas.ID_DEPARTAMENTO > 0)
                    {
                      $scope.rangoEstadisticas.COLOR = $scope.backgroundColorChartDepartamento[0];
                    }
                  }, function ( error ) {
                    toastr.error( error );
                  });
                }
                
                //grafica por regiones
                regiones = function(fecha,fechaFin,tipodatos)
                {
                  if (($scope.rangoEstadisticas.ID_REGION == 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0))
                  {
                    dashboardService.getDatosTablero($scope.rangoEstadisticas.ID_REGION,$scope.rangoEstadisticas.ID_DEPARTAMENTO,$scope.rangoEstadisticas.ID_DESPACHO,fecha,fechaFin,tipodatos,$scope.rangoEstadisticas.ID_BASE_COLOR).then( function ( response ) {
                      $scope.labelsChartRegion=response.data.labels;
                      $scope.dataChartRegion=response.data.data;
                      $scope.backgroundColorChartRegion=response.data.colors;
                      $scope.control_regiones = 2;
                      if (response.data.data.length == 1)
                      {
                        $scope.control_regiones = 1;
                      }
                    }, function ( error ) {
                      toastr.error( error );
                    });
                  }
                }

                //grafica por centros
                centros = function(fecha,fechaFin,tipodatos)
                {
                  dashboardService.getDatosTablero($scope.rangoEstadisticas.ID_REGION,$scope.rangoEstadisticas.ID_DEPARTAMENTO,$scope.rangoEstadisticas.ID_DESPACHO,fecha,fechaFin,tipodatos,$scope.rangoEstadisticas.ID_BASE_COLOR).then( function ( response ) {
                    $scope.labelsChartMapa1Temp=response.data.labels;
                    $scope.dataChartMapa1Temp=response.data.data;
                    $scope.backgroundColorChartMapa1Temp= response.data.colors;
                    $scope.mostrarTop = false;
                    $scope.topChartMapa1 = response.data.topgrupo;
                    $scope.topInicialChartMapa1 = response.data.topinicial;
                    $scope.topFinalChartMapa1 = response.data.topfinal;
                    if (response.data.data.length == 1)
                    {
                      $scope.labelsChartMapa1=response.data.labels;
                      $scope.dataChartMapa1=response.data.data;
                      $scope.backgroundColorChartMapa1 = response.data.colors;
                      $scope.control_centros = 1;
                    }
                    else
                    {
                      $scope.control_centros = 2;
                      if (response.data.topgrupo[0] > 0)
                      {
                        $scope.mostrarTop = true;

                        currentItemLocal = 1;
                        if ($scope.currentItem != undefined)
                        {
                          currentItemLocal = $scope.currentItem;
                        }
                        $scope.paginacionGraficaCasosCentrosDepartamento(currentItemLocal);
                      } 
                      else
                      {
                        $scope.labelsChartMapa1=response.data.labels;
                        $scope.dataChartMapa1=response.data.data;
                        $scope.backgroundColorChartMapa1= response.data.colors;
                        $scope.mostrarTop = false;
                      }
                    }
                  }, function ( error ) {
                    toastr.error( error );
                  });
                }

                //grafica por materias
                materias = function(fecha,fechaFin,tipodatos)
                {
                  dashboardService.getDatosTablero($scope.rangoEstadisticas.ID_REGION,$scope.rangoEstadisticas.ID_DEPARTAMENTO,$scope.rangoEstadisticas.ID_DESPACHO,fecha,fechaFin,tipodatos,$scope.rangoEstadisticas.ID_BASE_COLOR).then( function ( response ) {
                    $scope.labelsChartMateria=response.data.labels;
                    $scope.dataChartMateria=response.data.data;
                    $scope.backgroundColorChartMateria= response.data.colors;
                  }, function ( error ) {
                    toastr.error( error );
                  });
                }

                //grafica por materias
                idiomas = function(fecha,fechaFin,tipodatos)
                {
                  dashboardService.getDatosTablero($scope.rangoEstadisticas.ID_REGION,$scope.rangoEstadisticas.ID_DEPARTAMENTO,$scope.rangoEstadisticas.ID_DESPACHO,fecha,fechaFin,tipodatos,$scope.rangoEstadisticas.ID_BASE_COLOR).then( function ( response ) {
                    $scope.labelsChartIdioma=response.data.labels;
                    $scope.dataChartIdioma=response.data.data;
                    $scope.backgroundColorChartIdioma= response.data.colors;
                  }, function ( error ) {
                    toastr.error( error );
                  });
                }

                duration = 1500;
                offset = 20;
                
                $scope.scrollToElement = function(element)
                {
                  elemento = angular.element(document.getElementById(element));
                  $document.scrollToElement(elemento, offset, duration);
                }

                $scope.cargaEstadisticas=function(isValid){
                  
                  var fecha = moment($scope.rangoEstadisticas.FECHA).format("DD-MM-YYYY");
                  var fechaFin = moment($scope.rangoEstadisticas.FECHA_FIN).format("DD-MM-YYYY");
                  
                  if ( isValid) {
                    fechaTituloFechas($scope.rangoEstadisticas.FECHA,$scope.rangoEstadisticas.FECHA_FIN);
                    $scope.tipo_casos_texto2 = "";
                    $scope.tipo_casos_texto_inicial2 = "";
                    dashboardService.getDatosTablero($scope.rangoEstadisticas.ID_REGION,$scope.rangoEstadisticas.ID_DEPARTAMENTO,$scope.rangoEstadisticas.ID_DESPACHO,fecha,fechaFin,'registrados',$scope.rangoEstadisticas.ID_BASE_COLOR).then( function ( response ) {
                      $scope.dataMetricaRegistrados=response.data;                      
                      if ($scope.mostrarregistrados)
                      {
                        $scope.tipo_casos_texto = " "+$scope.dataMetricaRegistrados.TEXTO.toLowerCase()+" ";
                        $scope.tipo_casos_texto_inicial = " "+$scope.dataMetricaRegistrados.TEXTO+" ";
                      }
                    }, function ( error ) {
                      toastr.error( error );
                    });

                    dashboardService.getDatosTablero($scope.rangoEstadisticas.ID_REGION,$scope.rangoEstadisticas.ID_DEPARTAMENTO,$scope.rangoEstadisticas.ID_DESPACHO,fecha,fechaFin,'sesioncelebrada',$scope.rangoEstadisticas.ID_BASE_COLOR).then( function ( response ) {
                      $scope.dataMetricaMediados=response.data;
                      if ($scope.mostrarmediados)
                      {
                        $scope.tipo_casos_texto = " "+$scope.dataMetricaMediados.TEXTO.toLowerCase()+" ";
                        $scope.tipo_casos_texto_inicial = " "+$scope.dataMetricaMediados.TEXTO+" ";
                        $scope.tipo_casos_texto2 = " "+$scope.dataMetricaMediados.TEXTO2.toLowerCase()+" ";
                        $scope.tipo_casos_texto_inicial2 = " "+$scope.dataMetricaMediados.TEXTO2+" ";
                      }
                    }, function ( error ) {
                      toastr.error( error );
                    });

                    dashboardService.getDatosTablero($scope.rangoEstadisticas.ID_REGION,$scope.rangoEstadisticas.ID_DEPARTAMENTO,$scope.rangoEstadisticas.ID_DESPACHO,fecha,fechaFin,'conacuerdo',$scope.rangoEstadisticas.ID_BASE_COLOR).then( function ( response ) {
                      $scope.dataMetricaConAcuerdo=response.data;
                      if ($scope.mostrarconacuerdo)
                      {
                        $scope.tipo_casos_texto = " "+$scope.dataMetricaConAcuerdo.TEXTO.toLowerCase()+" ";
                        $scope.tipo_casos_texto = $scope.tipo_casos_texto.replace("acuerdo","Acuerdo");
                        $scope.tipo_casos_texto_inicial = " "+$scope.dataMetricaConAcuerdo.TEXTO+" ";
                      }
                    }, function ( error ) {
                      toastr.error( error );
                    });

                    dashboardService.getDatosTablero($scope.rangoEstadisticas.ID_REGION,$scope.rangoEstadisticas.ID_DEPARTAMENTO,$scope.rangoEstadisticas.ID_DESPACHO,fecha,fechaFin,'homologaciones',$scope.rangoEstadisticas.ID_BASE_COLOR).then( function ( response ) {
                      $scope.dataMetricaHomologaciones=response.data;
                      if ($scope.mostrarhomologados)
                      {
                        $scope.tipo_casos_texto = " "+$scope.dataMetricaHomologaciones.TEXTO.toLowerCase()+" ";
                        $scope.tipo_casos_texto_inicial = " "+$scope.dataMetricaHomologaciones.TEXTO+" ";
                      }
                    }, function ( error ) {
                      toastr.error( error );
                    });

                    dashboardService.getDatosTablero($scope.rangoEstadisticas.ID_REGION,$scope.rangoEstadisticas.ID_DEPARTAMENTO,$scope.rangoEstadisticas.ID_DESPACHO,fecha,fechaFin,'poblacionatendidasexo',$scope.rangoEstadisticas.ID_BASE_COLOR).then( function ( response ) {
                      $scope.labelsChartSexo=response.data.labels;
                      $scope.dataChartSexo=response.data.datagrafica;
                      $scope.backgroundColorChartSexo= response.data.colors;
                      $scope.dataMetricaPoblacionMujer=response.data.data[0];
                      $scope.dataMetricaPoblacionHombre=response.data.data[1];
                      $scope.dataMetricaPoblacionMujer.VALOR_TOTAL =  parseInt($scope.dataMetricaPoblacionMujer.VALOR) + parseInt($scope.dataMetricaPoblacionHombre.VALOR);
                      
                      if ($scope.mostrarpoblacion)
                      {
                        $scope.tipo_casos_texto = " "+$scope.dataMetricaPoblacionMujer.TEXTO.toLowerCase()+" ";
                        $scope.tipo_casos_texto_inicial = " "+$scope.dataMetricaPoblacionMujer.TEXTO+" ";
                      }

                    }, function ( error ) {
                      toastr.error( error );
                    });

                    //graficas
                    if ($scope.mostrarregistrados)
                    {
                      $scope.oa_tipo_caso ="o";
                      mapa(fecha,fechaFin,'registradosmapa');
                      regiones(fecha,fechaFin,'registradosregiones');
                      centros(fecha,fechaFin,'registradoscentros');
                      materias(fecha,fechaFin,'registradosmaterias');
                    }

                    if ($scope.mostrarmediados)
                    {
                      $scope.oa_tipo_caso ="a";
                      mapa(fecha,fechaFin,'mediadosmapa');
                      regiones(fecha,fechaFin,'mediadosregiones');
                      centros(fecha,fechaFin,'mediadoscentros');
                      materias(fecha,fechaFin,'mediadosmaterias');
                      idiomas(fecha,fechaFin,'mediadosidiomas');
                    }

                    if ($scope.mostrarconacuerdo)
                    {
                      $scope.oa_tipo_caso ="o";
                      mapa(fecha,fechaFin,'conacuerdomapa');
                      regiones(fecha,fechaFin,'conacuerdoregiones');
                      centros(fecha,fechaFin,'conacuerdocentros');
                      materias(fecha,fechaFin,'conacuerdomaterias');
                      idiomas(fecha,fechaFin,'conacuerdoidiomas');
                    }

                    if ($scope.mostrarhomologados)
                    {
                      $scope.oa_tipo_caso ="a";
                      mapa(fecha,fechaFin,'homologacionesmapa');
                      regiones(fecha,fechaFin,'homologacionesregiones');
                      centros(fecha,fechaFin,'homologacionescentros');
                      materias(fecha,fechaFin,'homologacionesmaterias');
                    }

                    if ($scope.mostrarpoblacion)
                    {
                      $scope.oa_tipo_caso ="a";
                      mapa(fecha,fechaFin,'poblacionatendidamapa');
                      regiones(fecha,fechaFin,'poblacionatendidaregiones');
                      centros(fecha,fechaFin,'poblacionatendidacentros');
                      materias(fecha,fechaFin,'poblacionatendidamaterias');
                    }
                  }
                }

                cambiaGrafica = function(parametro,arreglo,opcion)
                {
                  switch (opcion) {
                    case "region":
                      for (var i=0; i < arreglo.length; i++) 
                      {
                        if (arreglo[i].REGION === parametro) 
                        {
                          $scope.selectedRegion(arreglo[i],true);
                        }
                      }
                    break;
                    case "departamento":
                      for (var i=0; i < arreglo.length; i++) 
                      {
                        if (arreglo[i].DEPARTAMENTO === parametro) 
                        {
                          $scope.selectedDepartamento(arreglo[i],true);
                        }
                      }
                    break;
                  }
                }

                $scope.grafica_regiones_activa = false;
                $scope.grafica_departamentos_activa = false;

                $scope.onClickChartRegiones = function (points, evt, sergment) 
                {  
                  if (points.length > 0)
                  { 
                    $scope.grafica_regiones_activa = true;
                    $scope.grafica_departamentos_activa = false;
                    cambiaGrafica(points[0]._model.label,$scope.dataRegiones,'region');
                  }
                }

                $scope.onClickChartDepartamentos = function (points, evt, sergment) 
                {
                  if (points.length > 0)
                  { 
                    $scope.grafica_departamentos_activa = true;
                    cambiaGrafica(points[0]._model.label,$scope.dataDepartamentos,'departamento');
                  }
                }
                $scope.rangoEstadisticas={};
                $scope.rangoEstadisticas.ID_BASE_COLOR = $scope.ID_BASE_COLOR;
                $scope.rangoEstadisticas.ID_REGION = "0";
                $scope.rangoEstadisticas.ID_DEPARTAMENTO = "0";
                
                //para desplegar fecha inicial con un mes de anterioridad
                //initialDate = new Date();
                //temp = new Date(initialDate-365)
                //lastDayOfMonth = new Date(initialDate.getFullYear(), initialDate.getMonth(), initialDate.getDay());
                //console.log("lastDayOfMonth ",lastDayOfMonth, temp);
                //day = '' + lastDayOfMonth.getDate();
                //console.log("day ",day);
                //ant= day * 86399.9 //dias en segundos
                //finalDate = new Date(temp.setSeconds(ant*-1));
                //finalDate = new Date();
                //finalDate.setFullYear( finalDate.getFullYear() - 1 );

                /*
                temp = new Date(initialDate)
                lastDayOfMonth = new Date(initialDate.getFullYear(), initialDate.getMonth(), 0);
                day = '' + lastDayOfMonth.getDate();
                ant= day * 86399.9 //dias en segundos
                finalDate = new Date(temp.setSeconds(ant*-1))*/

                finalDate = new Date();
                finalDate.setFullYear( finalDate.getFullYear() - 1 ); //cambiar a -1, para que se cargue solo información del año anterior
                
                $scope.rangoEstadisticas.FECHA = finalDate;
                $scope.rangoEstadisticas.FECHA_FIN = new Date();
                //$scope.rangoEstadisticas.ID_RANGO="3";

                $scope.deshabilitar_centros = false;
                //$scope.rangoEstadisticas.ID_DEPARTAMENTO = "0";
                //$scope.rangoEstadisticas.ID_DESPACHO = "0";

                //$scope.focus_centro = false;
                $scope.mostrarregistrados = true;
                $scope.mostrarmediados = false;
                $scope.mostrarconacuerdo = false;
                $scope.mostrarhomologados = false;
                $scope.mostrarpoblacion = false;
                
                $scope.menumapa = false;               
                $scope.menucentros = false;
                $scope.menumaterias = false;
                $scope.menuidiomas = false;
                $scope.menusexos = false;
                $scope.menuregiones = false;
                $scope.menudepartamentos = false;

                $scope.dataMetricaRegistrados={};
                $scope.dataMetricaRegistradosMapa={};
                
                $scope.dataMetricaMediados={};
                $scope.dataMetricaConAcuerdo={};
                $scope.dataMetricaHomologaciones={};
                $scope.dataMetricaPoblacion={};
                $scope.dataMetricaPoblacionMujer={};
                $scope.dataMetricaPoblacionHombre={};
              
                $scope.zingMap1 = {
                  gui: {
                    contextMenu: {
                      visible:true
                      /*button: {
                        visible: false
                      }*/
                    }
                  },
                globals: {
                  shadow:true
                },
                "background-color":"#FFF",
                shapes: [
                  {
                    type: 'zingchart.maps',
                    options: {
                      name: 'gtm',
                      scrolling: true,
                      zooming: true,
                      style: {
                        label: {
                          visible:true
                        },
                        controls: {
                          visible: false
                        },
                        "background-color":"#F1F5F8",
                        "border-color":"#FFF",
                        "borderWidth": '1px',
                          hoverState: {
                            alpha: 0.3,
                            backgroundColor: '#FFF',
                            borderWidth: '3px'
                          }
                      }
                    }
                  }
                  ]
                };

                $scope.zingMap1Render = 
                {
                  output : "canvas",
                  events : 
                  {
                    shape_click : function(p) 
                    {  
                      recarga_mapa = true;
                      for (var i=0; i < $scope.dataDepartamentos.length; i++) 
                      {
                        if ($scope.dataDepartamentos[i].DEPARTAMENTO_ISO === p.shape.id) 
                        {
                          if (($scope.rangoEstadisticas.ID_REGION == 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0))
                          {
                            recarga_mapa = false;
                            $scope.selectedRegion($scope.dataDepartamentos[i],false);
                          }
                          else if (($scope.rangoEstadisticas.ID_REGION == $scope.dataDepartamentos[i].ID_REGION) &&
                                   ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0))
                          {
                            recarga_mapa = false;
                            $scope.selectedDepartamento($scope.dataDepartamentos[i],false);
                          }
                          break;
                        }
                      }
                      if ((recarga_mapa) && (p.shape.id !== "BLZ"))
                      {
                        if (($scope.rangoEstadisticas.ID_REGION == 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO > 0))
                        {
                          $scope.selectedDepartamento($scope.dataDepartamentos[0],false);
                        }
                        else if (($scope.rangoEstadisticas.ID_REGION > 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO > 0))
                        {
                          $scope.selectedDepartamento($scope.dataDepartamentos[0],false);
                        }
                        else if (($scope.rangoEstadisticas.ID_REGION > 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0))
                        {
                          $scope.selectedRegion($scope.dataDepartamentos[0],false);
                        }
                      }
                    }
                  }
                };

                $scope.enfocarPestana = function(id,externo)
                {
                  $scope.menumapa = false;               
                  $scope.menucentros = false;
                  $scope.menumaterias = false;
                  $scope.menuidiomas = false;
                  $scope.menusexos = false;
                  $scope.menuregiones = false;
                  $scope.menudepartamentos = false;
                  if (externo)
                  {
                    $scope.grafica_regiones_activa = false;
                    $scope.grafica_departamentos_activa = false;
                  }
                    
                  switch (id)
                  {
                    case 1:
                      //mapa
                      //if (($scope.rangoEstadisticas.ID_REGION == 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0))
                      //{
                        $scope.tooltip_filtrar_regiones = "Clic para filtrar la";
                      //}
                      //else if ($scope.rangoEstadisticas.ID_REGION > 0)
                      //{
                        $scope.tooltip_volver_regiones = "Cargar todas las regiones";
                        $scope.tooltip_volver_departamentos_regiones = "Cargar departamentos de la";
                        $scope.tooltip_filtrar_departamentos_regiones = "Cargar departamentos de la";
                        $scope.tooltip_volver_departamentos = "Cargar todos los departamentos";
                      //}
                      $scope.menumapa = true;
                    break;
                    case 2:
                      //centros
                      //if (($scope.rangoEstadisticas.ID_REGION == 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0))
                      //{
                        $scope.tooltip_filtrar_regiones = "Clic para filtrar centros de la";
                      //}
                      //else if ($scope.rangoEstadisticas.ID_REGION > 0)
                      //{
                        $scope.tooltip_volver_regiones = "Cargar centros de todas las regiones";
                        $scope.tooltip_filtrar_departamentos_regiones = "Cargar centros de la";
                        $scope.tooltip_volver_departamentos = "Cargar centros de todos los departamentos";
                        if ($scope.grafica_departamentos_activa)
                        {
                          $scope.tooltip_volver_regiones = "Volver a todas las regiones";
                          $scope.tooltip_filtrar_departamentos_regiones = "Volver a todos los departamentos de la";
                        }
                      //}
                      $scope.menucentros = true;
                    break;
                    case 3:
                      //materias
                      //if (($scope.rangoEstadisticas.ID_REGION == 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0))
                      //{
                        $scope.tooltip_filtrar_regiones = "Clic para filtrar distribución por materia de la";
                      //}
                      //else if ($scope.rangoEstadisticas.ID_REGION > 0)
                      //{
                        $scope.tooltip_volver_regiones = "Cargar distribución por materia de todas las regiones";
                        $scope.tooltip_filtrar_departamentos_regiones = "Cargar distribución por materia de la";
                        $scope.tooltip_volver_departamentos = "Cargar distribución por materia de todos los departamentos";
                      //}
                      $scope.menumaterias = true;
                    break;
                    case 4:
                      //idiomas
                      //if (($scope.rangoEstadisticas.ID_REGION == 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0))
                      //{
                        $scope.tooltip_filtrar_regiones = "Clic para filtrar distribución por idioma de la";
                      //}
                      //else if ($scope.rangoEstadisticas.ID_REGION > 0)
                      //{
                        $scope.tooltip_volver_regiones = "Cargar distribución por idioma de todas las regiones";
                        $scope.tooltip_filtrar_departamentos_regiones = "Cargar distribución por idioma de la";
                        $scope.tooltip_volver_departamentos = "Cargar distribución por idioma de todos los departamentos";
                      //}
                      $scope.menuidiomas = true;
                    break;
                    case 5:
                      //sexos
                      //if (($scope.rangoEstadisticas.ID_REGION == 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0))
                      //{
                        $scope.tooltip_filtrar_regiones = "Clic para filtrar distribución por sexo de la";
                      //}
                      //else if ($scope.rangoEstadisticas.ID_REGION > 0)
                      //{
                        $scope.tooltip_volver_regiones = "Cargar distribución por sexo de todas las regiones";
                        $scope.tooltip_filtrar_departamentos_regiones = "Cargar distribución por sexo de la";
                        $scope.tooltip_volver_departamentos = "Cargar distribución por sexo de todos los departamentos";
                      //}
                      $scope.menusexos = true;
                    break;
                    case 6:
                      //regiones
                      $scope.menuregiones = true;
                    break;
                    case 7:
                      //departamentos
                      //if (($scope.rangoEstadisticas.ID_REGION == 0) && ($scope.rangoEstadisticas.ID_DEPARTAMENTO == 0))
                      //{
                        $scope.tooltip_filtrar_regiones = "Clic para filtrar departamentos de la";
                      //}
                      //else if ($scope.rangoEstadisticas.ID_REGION > 0)
                      //{
                        $scope.tooltip_volver_regiones = "Cargar departamentos de todas las regiones";
                        $scope.tooltip_filtrar_departamentos_regiones = "Cargar departamentos de la";
                        if ($scope.grafica_regiones_activa)
                        {
                          $scope.tooltip_volver_regiones = "Volver a todas las regiones";
                        }
                      //}
                      $scope.menudepartamentos = true;
                    break;
                  }
                }
                $scope.enfocarPestana(1,true);

                $scope.cambiaTipoDato = function(opcion)
                {
                  $scope.mostrarregistrados = false;
                  $scope.mostrarmediados = false;
                  $scope.mostrarconacuerdo = false;
                  $scope.mostrarhomologados = false;
                  $scope.mostrarpoblacion = false;

                  switch(opcion) 
                  {
                    case 1: 
                      $scope.mostrarregistrados = true;
                      if (($scope.menuidiomas) || ($scope.menusexos))
                      {
                        $scope.enfocarPestana(3,true);
                      }
                      $scope.cargaEstadisticas(true);
                      break;
                    case 2: 
                      $scope.mostrarmediados = true;
                      if ($scope.menusexos)
                      {
                        $scope.enfocarPestana(3,true);
                      }
                      $scope.cargaEstadisticas(true);
                      break;
                    case 3: 
                      $scope.mostrarconacuerdo = true;
                      if ($scope.menusexos)
                      {
                        $scope.enfocarPestana(3,true);
                      }
                      $scope.cargaEstadisticas(true);
                      break;
                    case 4: 
                      $scope.mostrarhomologados = true;
                      if (($scope.menuidiomas) || ($scope.menusexos))
                      {
                        $scope.enfocarPestana(3,true);
                      }
                      $scope.cargaEstadisticas(true);
                      break;
                    case 5: 
                      $scope.mostrarpoblacion = true;
                      if ($scope.menuidiomas)
                      {
                        $scope.enfocarPestana(3,true);
                      }
                      $scope.cargaEstadisticas(true);
                      break;
                  }

                }

                /*
                $scope.deshabilitar_centros = false;
                //se obtienen los centros de mediacion
                $scope.centros = [];
                $scope.centros = dataDespacho.data;
                $scope.focus_centro = false;
                // CENTRO = authService.getLocalData('CENTRO');
                $scope.rangos = [];
                $scope.rangos.push(
                  {ID_RANGO:"1",RANGO:"Día"},
                  {ID_RANGO:"2",RANGO:"Semana"},
                  {ID_RANGO:"3",RANGO:"Mes"},
                  {ID_RANGO:"4",RANGO:"Año"},
                  {ID_RANGO:"-1",RANGO:"Total"}
                  );
                


                //se selecciona el centro de mediacion y se obtienen sus mediadores
                $scope.selectedCentro = function (item)
                {
                  $scope.centros.ID_DESPACHO = item.ID_DESPACHO;
                  $scope.cargaEstadisticas(true);
                }

                $scope.selectedRango = function (item)
                {
                  $scope.rangoEstadisticas.ID_RANGO = item.ID_RANGO;
                  $scope.cargaEstadisticas(true);
                }

                $scope.cargaEstadisticas=function(isValid){
                  
                  var fecha = moment($scope.rangoEstadisticas.FECHA).format("DD-MM-YYYY");
                  
                  if ( isValid) {
                    dashboardService.getMetrica1(fecha,$scope.rangoEstadisticas.ID_RANGO,$scope.centros.ID_DESPACHO).then( function ( response ) {
                      $scope.dataMetrica1=response.data;
                    }, function ( error ) {
                      toastr.error( error );
                    });
                    dashboardService.getMetrica2(fecha,$scope.rangoEstadisticas.ID_RANGO,$scope.centros.ID_DESPACHO).then( function ( response ) {
                      $scope.dataMetrica2=response.data;
                    }, function ( error ) {
                      toastr.error( error );
                    });
                    dashboardService.getMetrica3(fecha,$scope.rangoEstadisticas.ID_RANGO,$scope.centros.ID_DESPACHO).then( function ( response ) {
                      $scope.dataMetrica3=response.data;
                    }, function ( error ) {
                      toastr.error( error );
                    });
                    dashboardService.getMetrica4(fecha,$scope.rangoEstadisticas.ID_RANGO,$scope.centros.ID_DESPACHO).then( function ( response ) {
                      $scope.dataMetrica4=response.data;
                    }, function ( error ) {
                      toastr.error( error );
                    });
                    dashboardService.getMetrica5(fecha,$scope.rangoEstadisticas.ID_RANGO,$scope.centros.ID_DESPACHO).then( function ( response ) {
                      $scope.dataMetrica5=response.data;
                    }, function ( error ) {
                      toastr.error( error );
                    });
                    dashboardService.getMetrica6(fecha,$scope.rangoEstadisticas.ID_RANGO,$scope.centros.ID_DESPACHO).then( function ( response ) {
                      $scope.dataMetrica6=response.data;
                    }, function ( error ) {
                      toastr.error( error );
                    });
                    dashboardService.getMetrica7(fecha,$scope.rangoEstadisticas.ID_RANGO,$scope.centros.ID_DESPACHO).then( function ( response ) {
                      $scope.dataMetrica7=response.data;
                    }, function ( error ) {
                      toastr.error( error );
                    });
                    dashboardService.getMetrica8(fecha,$scope.rangoEstadisticas.ID_RANGO,$scope.centros.ID_DESPACHO).then( function ( response ) {
                      $scope.dataMetrica8=response.data;
                    }, function ( error ) {
                      toastr.error( error );
                    });

                    dashboardService.getMetrica9(fecha,$scope.rangoEstadisticas.ID_RANGO,$scope.centros.ID_DESPACHO).then( function ( response ) {
                      $scope.dataMetrica9=response.data;
                    }, function ( error ) {
                      toastr.error( error );
                    });
                    dashboardService.getMetrica10(fecha,$scope.rangoEstadisticas.ID_RANGO,$scope.centros.ID_DESPACHO).then( function ( response ) {
                      $scope.dataMetrica10=response.data;
                    }, function ( error ) {
                      toastr.error( error );
                    });
                    dashboardService.getMetrica11(fecha,$scope.rangoEstadisticas.ID_RANGO,$scope.centros.ID_DESPACHO).then( function ( response ) {
                      $scope.dataMetrica11=response.data;
                    }, function ( error ) {
                      toastr.error( error );
                    });
                    dashboardService.getMetrica12(fecha,$scope.rangoEstadisticas.ID_RANGO,$scope.centros.ID_DESPACHO).then( function ( response ) {
                      $scope.dataMetrica12=response.data;
                    }, function ( error ) {
                      toastr.error( error );
                    });
                    // dashboardService.getMetrica13(fecha,$scope.rangoEstadisticas.ID_RANGO,$scope.centros.ID_DESPACHO).then( function ( response ) {
                    //   $scope.dataMetrica13=response.data;
                    // }, function ( error ) {
                    //   toastr.error( error );
                    // });
                    // dashboardService.getMetrica14(fecha,$scope.rangoEstadisticas.ID_RANGO,$scope.centros.ID_DESPACHO).then( function ( response ) {
                    //   $scope.dataMetrica14=response.data;
                    // }, function ( error ) {
                    //   toastr.error( error );
                    // });
                    // dashboardService.getMetrica15(fecha,$scope.rangoEstadisticas.ID_RANGO,$scope.centros.ID_DESPACHO).then( function ( response ) {
                    //   $scope.dataMetrica15=response.data;
                    // }, function ( error ) {
                    //   toastr.error( error );
                    // });
                    // dashboardService.getMetrica16(fecha,$scope.rangoEstadisticas.ID_RANGO,$scope.centros.ID_DESPACHO).then( function ( response ) {
                    //   $scope.dataMetrica16=response.data;
                    // }, function ( error ) {
                    //   toastr.error( error );
                    // });
                    // dashboardService.getMetrica17(fecha,$scope.rangoEstadisticas.ID_RANGO,$scope.centros.ID_DESPACHO).then( function ( response ) {
                    //   $scope.dataMetrica17=response.data;
                    // }, function ( error ) {
                    //   toastr.error( error );
                    // });
                    // dashboardService.getMetrica18(fecha,$scope.rangoEstadisticas.ID_RANGO,$scope.centros.ID_DESPACHO).then( function ( response ) {
                    //   $scope.dataMetrica18=response.data;
                    // }, function ( error ) {
                    //   toastr.error( error );
                    // });

                    dashboardService.getCasosPorEstado(fecha,$scope.rangoEstadisticas.ID_RANGO,$scope.centros.ID_DESPACHO).then( function ( response ) {
                      $scope.casosPorEstado = [];
                      $scope.casosPorEstado = response.data;
                    }, function ( error ) {
                      toastr.error( error );
                    });

                    dashboardService.getCasosPorMateria(fecha,$scope.rangoEstadisticas.ID_RANGO,$scope.centros.ID_DESPACHO).then( function ( response ) {
                      $scope.casosPorMateria = [];
                      $scope.casosPorMateria = response.data;
                    }, function ( error ) {
                      toastr.error( error );
                    });
                    /*dashboardService.getMetrica9(fecha,$scope.rangoEstadisticas.RANGO).then( function ( response ) {
                      $scope.dataMetrica9=response.data;
                    }, function ( error ) {
                      toastr.error( error );
                    });
                    dashboardService.getMetrica10(fecha,$scope.rangoEstadisticas.RANGO).then( function ( response ) {
                      $scope.dataMetrica10=response.data;
                    }, function ( error ) {
                      toastr.error( error );
                    });
                    dashboardService.getMetrica11(fecha,$scope.rangoEstadisticas.RANGO).then( function ( response ) {
                      $scope.dataMetrica11=response.data;
                    }, function ( error ) {
                      toastr.error( error );
                    });
                    dashboardService.getMetrica12(fecha,$scope.rangoEstadisticas.RANGO).then( function ( response ) {
                      $scope.dataMetrica12=response.data;
                    }, function ( error ) {
                      toastr.error( error );
                    });

                    dashboardService.getMetrica13(fecha,$scope.rangoEstadisticas.RANGO).then( function ( response ) {
                      $scope.dataMetrica13=response.data;
                    }, function ( error ) {
                      toastr.error( error );
                    });

                    dashboardService.getMetrica14(fecha,$scope.rangoEstadisticas.RANGO).then( function ( response ) {
                      $scope.dataMetrica14=response.data;
                    }, function ( error ) {
                      toastr.error( error );
                    });
                  */
/*                    

                  }

                }
                 
                /*$scope.dataSolicitudesXEstado=dataSolicitudesXEstado.data;
                $scope.gridSolicitudes = angular.copy( $scope.gridOptionsLarge);
                $scope.gridSolicitudes.columnDefs = [
                                { name: 'ID_SOLICITUD', displayName: "#Solicitud", width:'15%'},
                                { name: 'ESTADO', displayName: "Estado" , width:'25%'},
                                { name: 'INICIO', displayName: "Inicio", width:'20%'},
                                { name: 'ULTIMO_MOV', displayName: "Ultimo Mov.", width:'20%'},
                                { name: 'CORRELATIVO', displayName: "Correlativo CAPE", width:'20%' }
                               ];
                $scope.gridSolicitudes.data=dataListaSolicitudesXEstado.data;


                $scope.dataComparativa=dataComparativa.data;
                $scope.dataComperatviaValores=dataComparativa.data.valores;
                $scope.comparativa={};
                $scope.comparativa.ID="7";

                $scope.selectedValorComparativa = function () {
                  console.log($scope.comparativa.ID);
                  dashboardService.getComparativa($scope.comparativa.ID).then( function ( response ) {
                      $scope.dataComparativa=response.data;
                  }, function ( error ) {
                    toastr.error( error );
                  });
                }*/
/*
                $scope.rangoEstadisticas={};
               
                // $scope.rangoEstadisticas.FECHA=moment.utc([2011,10,5]).format().toDate();
                $scope.rangoEstadisticas.FECHA = new Date();
                $scope.rangoEstadisticas.ID_RANGO="-1";
                //DEBERIA DE IR EL CENTRO
                
                //$scope.centros.ID_DESPACHO = CENTRO.ID_DESPACHO;

                $scope.centros.ID_DESPACHO = "0";

                $scope.dataMetrica1={};
                $scope.dataMetrica2={};
                $scope.dataMetrica3={};
                $scope.dataMetrica4={};
                $scope.dataMetrica5={};
                $scope.dataMetrica6={};
                $scope.dataMetrica7={};
                $scope.dataMetrica8={};
                $scope.dataMetrica9={};
                $scope.dataMetrica10={};
                $scope.dataMetrica11={};
                $scope.dataMetrica12={};
                // $scope.dataMetrica13={};
                // $scope.dataMetrica14={};
              
                $scope.cargaEstadisticas(true);

*/

                }]
            }
          }
        })
    }
  ]
);
